<template>
  <div>
    <span class="label">排序</span>
    <span class="handle" :class="{'active': value == 1}" @click="sort('default')">智能排序
    </span>
    <span class="handle" :class="{'active': value == 2 || value == 3}" @click="sort('date')">成立日期
      <img v-if="value != 2 && value != 3" src="../../assets/default.png" alt="">
      <img v-if="value == 2" src="../../assets/order.png" alt="">
      <img v-if="value == 3" src="../../assets/reverse.png" alt="">
    </span>
    <span class="handle" :class="{'active': value == 4 || value == 5}" @click="sort('capital')">注册资本
      <img v-if="value != 4 && value != 5" src="../../assets/default.png" alt="">
      <img v-if="value == 4" src="../../assets/order.png" alt="">
      <img v-if="value == 5" src="../../assets/reverse.png" alt="">
    </span>
  </div>
</template>
<script>
export default {
  props: ['value'],
  data() {
    return {};
  },
  methods: {
    sort(type) {
      switch (type) {
        case 'default':
          this.$emit('input', '1');
          break;
        case 'date':
          if (this.value == '2') {
            this.$emit('input', '3');
          } else {
            this.$emit('input', '2');
          }
          break;
        case 'capital':
          if (this.value == '4') {
            this.$emit('input', '5');
          } else {
            this.$emit('input', '4');
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  position: relative;
  padding: 0 20px;
  &:after {
    content: '';
    width: 2px;
    height: 18px;
    background: #ccc;
    position: absolute;
    top: -1px;
    right: 0px;
  }
}
.handle {
  cursor: pointer;
  margin-left: 10px;
  color: #999;
  &.active {
    color: var(--theme-color);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/global/sort.vue